var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-footer"},[_c('a',{staticClass:"link-to-bank",attrs:{"href":_vm.source.links.login,"target":"_blank"}},[_c('img',{attrs:{"src":require(("@/assets/bank-logos/" + (_vm.source.logoFile)))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7766a71e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/credentials/credentials-card/BankFooter.vue
// module id = null
// module chunks = 